import { ClientAnalyticsData } from '../../types';

export const mockClientAnalyticsData: ClientAnalyticsData = {
  acquisition: {
    totalAcquired: 247,
    acquisitionRate: 23.4,
    leadConversion: 18.7,
    marketingEffectiveness: 75.2,
  },
  retention: {
    retentionRate: 87.3,
    churnRate: 12.7,
    averageLifespan: 14.8, // months
    cohortAnalysis: [
      { cohort: '2024-01', period: 1, retentionRate: 95.2, clientCount: 42 },
      { cohort: '2024-01', period: 2, retentionRate: 89.7, clientCount: 39 },
      { cohort: '2024-01', period: 3, retentionRate: 85.1, clientCount: 37 },
      { cohort: '2024-01', period: 6, retentionRate: 78.3, clientCount: 34 },
      { cohort: '2024-02', period: 1, retentionRate: 96.8, clientCount: 38 },
      { cohort: '2024-02', period: 2, retentionRate: 91.2, clientCount: 36 },
      { cohort: '2024-02', period: 3, retentionRate: 87.4, clientCount: 35 },
      { cohort: '2024-03', period: 1, retentionRate: 94.1, clientCount: 45 },
      { cohort: '2024-03', period: 2, retentionRate: 88.6, clientCount: 42 },
      { cohort: '2024-04', period: 1, retentionRate: 97.3, clientCount: 41 },
    ],
  },
  engagement: {
    sessionAttendance: 82.4,
    goalCompletion: 76.8,
    appUsage: 68.9,
    communicationFrequency: 91.2,
  },
  demographics: {
    ageDistribution: [
      { range: '18-25', count: 34, percentage: 13.8 },
      { range: '26-35', count: 89, percentage: 36.0 },
      { range: '36-45', count: 72, percentage: 29.1 },
      { range: '46-55', count: 38, percentage: 15.4 },
      { range: '56+', count: 14, percentage: 5.7 },
    ],
    genderDistribution: [
      { gender: 'Female', count: 147, percentage: 59.5 },
      { gender: 'Male', count: 95, percentage: 38.5 },
      { gender: 'Other', count: 5, percentage: 2.0 },
    ],
    tierDistribution: [
      { tier: 'Premium', count: 89, percentage: 36.0, revenue: 267000 },
      { tier: 'Standard', count: 124, percentage: 50.2, revenue: 186000 },
      { tier: 'Basic', count: 34, percentage: 13.8, revenue: 34000 },
    ],
    locationDistribution: [
      { location: 'North America', count: 142, percentage: 57.5 },
      { location: 'Europe', count: 67, percentage: 27.1 },
      { location: 'Asia Pacific', count: 28, percentage: 11.3 },
      { location: 'Other', count: 10, percentage: 4.1 },
    ],
  },
};

export const mockAcquisitionTrend = [
  { month: '2023-07', acquired: 18, target: 20, leadConversion: 16.2 },
  { month: '2023-08', acquired: 23, target: 22, leadConversion: 18.9 },
  { month: '2023-09', acquired: 19, target: 22, leadConversion: 15.7 },
  { month: '2023-10', acquired: 27, target: 25, leadConversion: 21.3 },
  { month: '2023-11', acquired: 31, target: 25, leadConversion: 23.8 },
  { month: '2023-12', acquired: 29, target: 28, leadConversion: 22.1 },
  { month: '2024-01', acquired: 33, target: 30, leadConversion: 24.7 },
  { month: '2024-02', acquired: 35, target: 32, leadConversion: 26.4 },
  { month: '2024-03', acquired: 38, target: 35, leadConversion: 28.1 },
  { month: '2024-04', acquired: 42, target: 38, leadConversion: 31.2 },
  { month: '2024-05', acquired: 39, target: 40, leadConversion: 29.8 },
  { month: '2024-06', acquired: 44, target: 42, leadConversion: 33.5 },
];

export const mockRetentionByTier = [
  { tier: 'Premium', retentionRate: 94.2, churnRate: 5.8, avgLifespan: 18.4 },
  { tier: 'Standard', retentionRate: 85.7, churnRate: 14.3, avgLifespan: 13.2 },
  { tier: 'Basic', retentionRate: 76.1, churnRate: 23.9, avgLifespan: 9.8 },
];

export const mockEngagementMetrics = [
  { metric: 'Session Attendance', value: 82.4, target: 85.0, trend: 'up', change: 3.2 },
  { metric: 'Goal Completion', value: 76.8, target: 80.0, trend: 'up', change: 5.1 },
  { metric: 'App Usage', value: 68.9, target: 75.0, trend: 'stable', change: -0.3 },
  { metric: 'Communication Frequency', value: 91.2, target: 90.0, trend: 'up', change: 2.8 },
  { metric: 'Program Adherence', value: 79.3, target: 82.0, trend: 'up', change: 4.7 },
  { metric: 'Check-in Compliance', value: 85.6, target: 88.0, trend: 'stable', change: 1.2 },
];

export const mockClientLifecycle = [
  { stage: 'Lead', count: 186, conversionRate: 31.2 },
  { stage: 'Trial', count: 58, conversionRate: 72.4 },
  { stage: 'New Client', count: 42, conversionRate: 89.3 },
  { stage: 'Active', count: 194, conversionRate: 96.7 },
  { stage: 'At Risk', count: 28, conversionRate: 67.9 },
  { stage: 'Churned', count: 15, conversionRate: 0 },
]; 